<template lang="pug">
.wagtail-content
  component(v-for="(item, index) in modifiedContent" :is="`wagtail_${item.type}`" :key="item.id" :value="item.value" :class="index === 1 && 'scrollto'").wagtail-content-item
</template>

<script>
import wagtail_titled_paragraphs from '~/components/wagtail/TitledParagraphs'
import wagtail_paragraph from '~/components/wagtail/Paragraphs'
import wagtail_title from '~/components/wagtail/Title'
import wagtail_project_promo from '~/components/wagtail/ProjectPromo'
import wagtail_form from '~/components/wagtail/form/Form'
import wagtail_vacancy_promo from '~/components/wagtail/VacancyPromo'
import wagtail_list from '~/components/wagtail/List'
import wagtail_rich_text_quote from '~/components/wagtail/RichTextQuote'
import wagtail_form_with_text from '~/components/wagtail/FormWithText'
import wagtail_color_richtext_overlay from '~/components/wagtail/ColorRichtextOverlay'
import wagtail_quote from '~/components/wagtail/Quote'
import wagtail_titled_quote from '~/components/wagtail/TitledQuote'
import wagtail_image_enlarging from '~/components/wagtail/ImageEnlarging'
import wagtail_video from '~/components/wagtail/Video'

export default {
  props: {
    content: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    wagtail_titled_paragraphs,
    wagtail_paragraph,
    wagtail_title,
    wagtail_project_promo,
    wagtail_form,
    wagtail_vacancy_promo,
    wagtail_list,
    wagtail_rich_text_quote,
    wagtail_form_with_text,
    wagtail_color_richtext_overlay,
    wagtail_quote,
    wagtail_titled_quote,
    wagtail_image_enlarging,
    wagtail_video
  },
  computed: {
    modifiedContent: function () {
      let newContent = [...this.content]
      if (newContent.length) {
        if (newContent[newContent.length - 1].type === 'form') newContent.pop()
      }
      return newContent
    }
  }
}
</script>

<style lang="scss" scoped>
.wagtail-content-item {
  margin-bottom: 100px;
  color: $text-dark;
}

.wagtail-content-item:deep(ol) {
  padding-left: 1rem;

  @include mobile {
    padding-left: 1.5rem;
  }
}

.wagtail-content-item:deep(ol>li) {
  list-style: decimal !important;
  margin-bottom: 1rem;
}
</style>
